// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__33cJ-","inputClass":"Search_inputClass__NpXOT","clearButton":"Search_clearButton__XsFhP","clearIcon":"Search_clearIcon__tnOcC"};